<template>
    <v-dialog v-model="edits.songDupModal" width="600" v-if="edits.song" :persistent="true">
      <v-card>
        <v-card-title class="black">
          <h2 class="pl-2 text-uppercase font-weight-light">
            Remove Duplicate Song
          </h2>
        </v-card-title>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <p><b>WARNING: You are about to remove a song!</b></p>
              <p>This tool should be used to remove a duplicate song.</p>
              <p>Select the original (master) song to move stats and video references from this song to.</p>
              <p>After all references are moved, THIS SONG WILL BE DELETED.</p>
              <p>Song to be removed: <u>{{edits.song.ac}}</u></p>
              <br/><br/>
            </v-flex>
            <v-flex xs12>
              <v-autocomplete
                label="Correct Song"
                class="ma-0 pa-0"
                :items="songs"
                v-model="formData.main_song_id"
                item-text="ac"
                item-value="id"
                color="secondary"
                :dense="true"
                :hide-details="true"
                placeholder="Search for Songs by Title"
                :menu-props="{contentClass: 'text-uppercase', 'class': 'mt-0 pt-0'}"/>
            </v-flex>
          </v-layout>
          <br/><small class="ml-2">* Required fields</small>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <div>
            <v-progress-circular indeterminate v-if="busy"></v-progress-circular>
            <v-btn color="secondary" flat @click="close()" :disabled="busy">Close</v-btn>
            <v-btn color="secondary black--text" @click="submit()" :disabled="busy">Submit</v-btn>
          </div>
        </v-card-actions>
      </v-card>

    </v-dialog>
</template>

<script>

import { setSongArtists, setSongScores } from '../services/database'

export default {
  name: 'song-dup-modal',
  props: {
    edits: Object
  },
  data () {
    return {
      busy: false,
      formData: {
        main_song_id: null
      },
      rules: {
        main_song_id: [
          v => !!v || 'Select the correct song.'
        ]
      }
    }
  },
  computed: {
    songs () {
      if (!this.edits.song) return []
      // remove duplicate song from list
      return this.$database.songs.array.filter(s => {
        return s.id !== this.edits.song.id
      })
    }
  },
  methods: {
    resetData () {
      this.formData.main_song_id = null
    },
    submit () {
      this.busy = true
      return this.$api.songs.update(
        this.edits.song.id,
        this.formData,
        '', // prefix
        '/duplicate_of' // postfix
      ).then(masterSong => {
        var songs = this.$database.songs
        songs.reload().then(_ => {
          setSongScores(songs) // not a promise
          var promises = [
            setSongArtists(songs),
            this.$database.videos.reload(),
            this.$database.stats.reload()
          ]
          return Promise.all(promises).then(_ => {
            this.$router.push(`/songs/${masterSong.id}`)
            this.close()
            this.busy = false
          })
        })
      })
        .catch(error => {
          console.log(error)
          this.busy = false
        })
    },
    close () {
      this.edits.songDupModal = false
    }
  },
  watch: {
    'edits.songDupModal': function (val) {
      this.resetData()
    }
  }
}
</script>
